export default __webpack_public_path__ + "static/media/edgy, adult, funny.1d5c95c6.jpg";